import type { JSX } from 'react';

import { Loader2, Plus, RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface WebhooksAvailablePanelHeaderProps {
  isFetching: boolean;
  onCreate: () => void;
  onRefresh: () => void;
}

const WebhooksAvailablePanelHeader = ({
  isFetching,
  onCreate,
  onRefresh,
}: WebhooksAvailablePanelHeaderProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0">
        <h3 id="webhooks-disponibles-heading" className="m-0 text-base font-bold text-text-default font-display">
          Webhooks disponibles
        </h3>
        <p className="m-0 mt-1 text-sm text-text-muted font-body">
          Webhooks configurados para este proyecto (todas las áreas, habilitados y deshabilitados).
        </p>
      </div>
      <div className="flex shrink-0 flex-wrap items-center gap-2">
        <Button
          type="button"
          variant="default"
          size="sm"
          className="gap-2 bg-brand-vivid text-text-inverse hover:bg-brand-sky-dark"
          onClick={onCreate}
        >
          <Plus className="size-4 shrink-0" aria-hidden />
          Nuevo webhook
        </Button>
        <Button type="button" variant="outline" size="sm" className="gap-2" disabled={isFetching} onClick={onRefresh}>
          {isFetching ? (
            <Loader2 className="size-4 animate-spin" aria-hidden />
          ) : (
            <RefreshCw className="size-4" aria-hidden />
          )}
          Actualizar
        </Button>
      </div>
    </div>
  );
};

export default WebhooksAvailablePanelHeader;
